import {toast} from 'react-toastify';

// Function to play sound
const playNotificationSound = () => {
  const audio = new Audio('/sounds/dgChatAlert.mp3');
  audio.play().catch((err) => console.error('Audio play failed', err));
};

// Generic function to show toast + sound
export const showNotification = (message = 'New message received!') => {
  toast.info(message, {
    position: 'bottom-right',
    autoClose: 3000,
    hideProgressBar: false,
    closeOnClick: true,
    pauseOnHover: true,
    draggable: true,
  });

  playNotificationSound();
};
